import { useTranslation } from 'react-i18next';
import { Scale } from 'lucide-react';
import { Badge } from '../ui/badge';
import { cn } from '@/lib/utils';
import type { Placement } from '../../services/round-scores';

/**
 * What a tie-break did to a place, beside it (issue #364): a small mark when
 * one decided it, "Spareggio in corso" while one is being climbed for it.
 * Nothing otherwise — and nothing on a stage's results, which are the places
 * alone (the caller leaves it out there).
 */
export function TiebreakMark({ tiebreak, className }: { tiebreak: Placement['tiebreak']; className?: string }) {
  const { t } = useTranslation();

  if (tiebreak === 'decided') {
    return (
      <Scale
        className={cn('inline size-3.5 shrink-0 text-amber-600 dark:text-amber-400', className)}
        aria-label={t('tiebreaks.decided')}
        role="img"
        data-testid="tiebreak-decided"
      >
        <title>{t('tiebreaks.decided')}</title>
      </Scale>
    );
  }

  if (tiebreak === 'pending') {
    return (
      <Badge
        variant="outline"
        className={cn('border-amber-500 font-normal text-amber-700 dark:text-amber-300', className)}
        data-testid="tiebreak-pending"
      >
        {t('tiebreaks.pending')}
      </Badge>
    );
  }

  return null;
}

export default TiebreakMark;
